import React from "react";
import { useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import {
  BASE_URL,
  handleDynamicRequest,
  useDispatch,
  useNavigate,
} from "../../Common/CommonExport";

import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Paper,
  capitalize,
} from "@mui/material";

import CandidateResults from "./CandidateResults";

const CandidateResultSection = () => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const location = useLocation();

  const [filterLoading, setFilterLoading] = useState(false);

  const [isPreview, setIsPreview] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [linkedInProfile, setLinkedInProfile] = useState("");
  const [jobRole, setJobRole] = useState(false);
  const [readyToSwitch, setReadyToSwitch] = useState(false);
  const [trainingRequired, setTrainingRequired] = useState(false);
  const [relevantExperience, setRelevantExperience] = useState(0);
  const [totalExperience, setTotalExperience] = useState(0);
  const [currentStatus, setCurrentStatus] = useState("");
  const [candidateAssessmentDetails, setCandidateAssessmentDetails] =
    useState(null);
  const [selectionStatus, setSelectionStatus] = useState("");
  const [tabList, setTabList] = useState(["Candidate Details"]);
  const [CandidateResult, setCandidateResult] = useState([]);

  const [skillData, setSkillData] = useState([]);

  const [communicationSkill, setCommunicationSkill] = useState(0);
  const [skillWisePerformance, setSkillWisePerformance] = useState([]);
  const [additionalSkills, setAdditionalSkills] = useState([]);

  const { candidateAssessmentId } = useParams();
  const [alertMessage, setAlertMessage] = useState({ success: "", error: "" });

  const searchParams = new URLSearchParams(location.search);
  const round = searchParams.get("round");
  const interviewId = searchParams.get("interviewId");

  const [takeaways, setTakeaways] = useState(() => {
    const storedTakeaways = localStorage.getItem(`takeaways_${interviewId}`);
    return storedTakeaways ? JSON.parse(storedTakeaways) : [];
  });
  const [readyToUploadImg, setReadyToUploadImg] = useState(() => {
    const savedData = localStorage.getItem(`${interviewId}UploadImg`);
    if (savedData) {
      return JSON.parse(savedData);
    }
    return [];
  });
  const [readyToUploadVideo, setReadyToUploadVideo] = useState(() => {
    const savedData = localStorage.getItem(`${interviewId}UploadVideo`);
    if (savedData) {
      return JSON.parse(savedData);
    }
    return [];
  });

  useEffect(() => {
    localStorage.setItem(
      `${interviewId}UploadImg`,
      JSON.stringify(readyToUploadImg)
    );
  }, [readyToUploadImg, interviewId]);

  useEffect(() => {
    localStorage.setItem(
      `${interviewId}UploadVideo`,
      JSON.stringify(readyToUploadVideo)
    );
  }, [readyToUploadVideo, interviewId]);

  useEffect(() => {
    console.log(candidateAssessmentId, 111);
    const fetchCandidateAssessment = async () => {
      const requestBody = {};
      const method = "GET";
      const url = `${BASE_URL}/public/candidateResult/${candidateAssessmentId}`;
      const wrongResponse = () => {
        setAlertMessage({ success: "", error: "Error" });
      };
      const rightResponse = (data) => {
        if (data) {
          console.log(data);
          setCandidateAssessmentDetails(data);
          setCurrentStatus(data.currentStatus);
          updateTabList(data.currentStatus);
        }
      };
      handleDynamicRequest(
        method,
        url,
        requestBody,
        wrongResponse,
        rightResponse
      );
    };
    // const fetchCandidateAssessment = async () => {
    //   try {
    //     console.log(1);
    //     const response =
    //       await `${serverURL2}/public/candidateResult/${candidateAssessmentId}`;
    //     if (!response.ok) {
    //       throw new Error(`HTTP error! Status: ${response.status}`);
    //     }
    //     const candidateCurrentStatus = await response.json();
    //     if (candidateCurrentStatus) {
    //       setCandidateAssessmentDetails(candidateCurrentStatus);
    //       setCurrentStatus(candidateCurrentStatus.currentStatus);
    //       updateTabList(candidateCurrentStatus.currentStatus);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching candidate assessment:", error);
    //   }
    // };

    if (candidateAssessmentId) {
      fetchCandidateAssessment();
    }
  }, [candidateAssessmentId]);

  const updateTab = (round) => {
    if (round === "Round 1") {
      setCurrentTabIndex(1);
    } else if (round === "Round 2") {
      setCurrentTabIndex(2);
    } else if (round === "HR") {
      setCurrentTabIndex(4);
    }
  };

  const updateTabList = (currentStatus) => {
    let updatedTabList = ["Candidate Details"];

    if (currentStatus) {
      if (currentStatus.includes("R1 Cancelled")) {
        updatedTabList = ["Candidate Details"];
        setCurrentTabIndex(0);
      } else if (currentStatus.includes("R1 Scheduled")) {
        updatedTabList = ["Candidate Details", "Round 1"];
        updateTab(round);
      } else if (
        currentStatus.includes("R1 Passed") ||
        currentStatus.includes("R1 Failed") ||
        currentStatus.includes("R2 Cancelled")
      ) {
        updatedTabList = ["Candidate Details", "Round 1", "Summary"];
        updateTab(round);
      } else if (
        currentStatus.includes("R2 Scheduled") ||
        currentStatus.includes("R2 Passed") ||
        currentStatus.includes("R2 Failed") ||
        currentStatus.includes("HR Cancelled")
      ) {
        updatedTabList = ["Candidate Details", "Round 1", "Round 2", "Summary"];
        updateTab(round);
      } else if (
        currentStatus.includes("HR Scheduled") ||
        currentStatus.includes("HR Passed") ||
        currentStatus.includes("HR Failed") ||
        currentStatus.includes("Cancelled Hire")
      ) {
        updatedTabList = [
          "Candidate Details",
          "Round 1",
          "Round 2",
          "Summary",
          "HR Round",
        ];
        updateTab(round);
      } else if (currentStatus.includes("Hired")) {
        updatedTabList = [
          "Candidate Details",
          "Round 1",
          "Round 2",
          "Summary",
          "HR Round",
        ];
        if (round) {
          updateTab(round);
        }
      }
    }
    setTabList(updatedTabList);
  };

  useEffect(() => {
    if (interviewId) {
      localStorage.setItem(
        `takeaways_${interviewId}`,
        JSON.stringify(takeaways)
      );
    }
  }, [takeaways, interviewId]);

  useEffect(() => {
    if (skillData) {
      const initialSkillWisePerformance = skillData.map((skill) => ({
        skill: skill.skill.name,
        score: skill.marksObtained,
        totalScore: skill.totalScore,
        rating: 0,
      }));
      setSkillWisePerformance(initialSkillWisePerformance);
    }
  }, [skillData]);

  useEffect(() => {
    if (CandidateResult?.additionalJobRoles?.jobRoleAddition) {
      const initialAdditionalSkills =
        CandidateResult.additionalJobRoles.jobRoleAddition.map((skill) => ({
          skill: skill,
          rating: 0,
        }));
      if (CandidateResult.interviewresult) {
        setAdditionalSkills(CandidateResult.interviewresult.additionalSkills);
      } else {
        setAdditionalSkills(initialAdditionalSkills);
      }
    }
  }, [CandidateResult]);

  useEffect(() => {
    setIsPreview(false);
  }, [currentTabIndex]);

  return (
    // <Box sx={{ height: "100%" }}>
    //   <Tabs
    //     className={classes.tabHeader}
    //     value={currentTabIndex}
    //     onChange={handleChange}
    //     variant="scrollable"
    //     scrollButtons="auto"
    //   >
    //     {tabList.map((item) => (
    //       <Tab label={item} key={item} />
    //     ))}
    //   </Tabs>
    //   {currentTabIndex === 0 && candidateAssessmentId && currentStatus && (
    //     <CandidateResult
    //       candidateAssessmentId={
    //         candidateAssessmentId ||
    //         location.state.candidateAssessmentId ||
    //         candidateAssessmentDetails.assessmentId._id
    //       }
    //       candidateAssessmentDetails={candidateAssessmentDetails}
    //       setCandidateAssessmentDetails={setCandidateAssessmentDetails}
    //     />
    //   )}
    // </Box>
    <>
      <Box sx={{ padding: "16px" }}>
        {" "}
        {/* Added padding to prevent overlap */}
        <AppBar
          position="static"
          elevation={0}
          sx={{ backgroundColor: "transparent" }}
        >
          <Paper
            sx={{
              width: "100%",
              padding: "12px 16px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
              {candidateAssessmentDetails?.assessmentId?.name ||
                "Assessment Details"}
            </Typography>
          </Paper>
        </AppBar>
        <Box sx={{ marginTop: "16px" }}>
          {" "}
          {/* Added margin to push content down */}
          <CandidateResults
            candidateAssessmentId={candidateAssessmentId}
            candidateAssessmentDetails={candidateAssessmentDetails}
            setCandidateAssessmentDetails={setCandidateAssessmentDetails}
          />
        </Box>
      </Box>
    </>
  );
};

export default CandidateResultSection;
